import React from 'react';
import './index.scss';

const getCurrentYear = () => new Date().getFullYear();

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row container_resources">
          <h5>Resources</h5>
          <div className="container_resources_list">
            <div className="container_resources_list_item">
              <a href="https://kata-log.rocks/tdd" target="_blank">
                Katas to learn TDD - Kata-Log
              </a>
            </div>
            <div className="container_resources_list_item">
              <a href="http://www.tddbudy.com" target="_blank">
                TddBuddy
              </a>
            </div>
            {/* <div className="col-md-3 mx-auto"> */}
            <div className="container_resources_list_item">
              <a href="https://www.programmingwithwolfgang.com/tdd-kata/" target="_blank">
                TDD Kata | Programming With Wolfgang
              </a>
            </div>
            <div className="container_resources_list_item">
              <a
                href="https://www.michael-whelan.net/code-katas-for-practicing-tdd/"
                target="_blank"
              >
                TDD Katas - Michael Whelan
              </a>
            </div>
          </div>
        </div>
        <p className="float-end">
          <a href="https://github.com/codedoh" target="_blank">
            Powered by CodeDoh Engine
          </a>
        </p>
        <p>© 2021–{getCurrentYear()} All rights reserved.</p>

        <a href="http://www.dongwest.net/" className="small-link" target="_blank">
          Recommended by DongWest.net
        </a>
      </div>
    </footer>
    // <footer class="footer footer--ckeditor-4" role="contentinfo">
    //   <div class="section-container footer-site-map">
    //     <div class="footer-menu__category-items">
    //       <div class="footer-menu__wrapper" role="navigation">
    //         <h2>Products</h2>
    //         <ul class="footer-menu">
    //           <li>
    //             <a href="/ckeditor-5/">CKEditor 5</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-4/">CKEditor 4</a>
    //           </li>
    //           <li>
    //             <a href="/ckfinder/">CKFinder</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-cloud-services/easy-image/">Easy Image</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-4/accessibility-checker/">Accessibility Checker</a>
    //           </li>
    //         </ul>
    //       </div>
    //       <div class="footer-menu__wrapper" role="navigation">
    //         <h2>Collaboration</h2>
    //         <ul class="footer-menu">
    //           <li>
    //             <a href="/collaboration/comments/">Comments</a>
    //           </li>
    //           <li>
    //             <a href="/collaboration/track-changes/">Track changes</a>
    //           </li>
    //           <li>
    //             <a href="/collaboration/real-time-collaborative-editing/">
    //               Real-time collaboration
    //             </a>
    //           </li>
    //         </ul>
    //       </div>
    //       <div class="footer-menu__wrapper" role="navigation">
    //         <h2>Support</h2>
    //         <ul class="footer-menu">
    //           <li>
    //             <a href="https://github.com/ckeditor/">CKEditor GitHub</a>
    //           </li>
    //           <li>
    //             <a href="https://ckeditor.com/docs/">Documentation</a>
    //           </li>
    //           <li>
    //             <a href="https://support.ckeditor.com/hc/en-us/">Help center</a>
    //           </li>
    //           <li>
    //             <a href="//dashboard.ckeditor.com/login/">Customer login</a>
    //           </li>
    //           <li>
    //             <a href="https://status.cke-cs.com/">Status page</a>
    //           </li>
    //         </ul>
    //       </div>
    //       <div class="footer-menu__wrapper" role="navigation">
    //         <h2>Resources</h2>
    //         <ul class="footer-menu">
    //           <li>
    //             <a href="/ckeditor-5/resources/">CKEditor 5</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-4/resources/">CKEditor 4</a>
    //           </li>
    //           <li>
    //             <a href="/ckfinder/resources/">CKFinder</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-cloud-services/easy-image/resources/">Easy Image</a>
    //           </li>
    //           <li>
    //             <a href="/ckeditor-4/accessibility-checker/resources/">Accessibility Checker</a>
    //           </li>
    //         </ul>
    //       </div>
    //       <div class="footer-menu__wrapper" role="navigation">
    //         <h2>Explore</h2>
    //         <ul class="footer-menu">
    //           <li>
    //             <a href="/pricing/">Pricing</a>
    //           </li>
    //           <li>
    //             <a href="/contact/">Contact us</a>
    //           </li>
    //           <li>
    //             <a href="/case-studies/">Case studies</a>
    //           </li>
    //           <li>
    //             <a href="https://cksource.com/">About us</a>
    //           </li>
    //           <li>
    //             <a href="/blog/">Blog</a>
    //           </li>
    //         </ul>
    //         <div class="footer-social">
    //           <ul>
    //             <li>
    //               <a
    //                 class="icon icon--small"
    //                 href="https://www.facebook.com/CKEditor"
    //                 target="_blank"
    //                 rel="noopener noreferrer nofollow"
    //               >
    //                 <svg class="icon__body" role="img" aria-label="Facebook">
    //                   {/* <use xlink:href="#facebook"></use> */}
    //                 </svg>
    //               </a>
    //             </li>
    //             <li>
    //               <a
    //                 class="icon icon--small"
    //                 href="https://www.twitter.com/ckeditor"
    //                 target="_blank"
    //                 rel="noopener noreferrer nofollow"
    //               >
    //                 <svg class="icon__body" role="img" aria-label="Twitter">
    //                   {/* <use xlink:href="#twitter"></use> */}
    //                 </svg>
    //               </a>
    //             </li>
    //             <li>
    //               <a
    //                 class="icon icon--small"
    //                 href="https://www.linkedin.com/company/cksource/"
    //                 target="_blank"
    //                 rel="noopener noreferrer nofollow"
    //               >
    //                 <svg class="icon__body" role="img" aria-label="LinkedIn">
    //                   {/* <use xlink:href="#linkedin"></use> */}
    //                 </svg>
    //               </a>
    //             </li>
    //             <li>
    //               <a
    //                 class="icon icon--small"
    //                 href="https://medium.com/content-uneditable"
    //                 target="_blank"
    //                 rel="noopener noreferrer nofollow"
    //               >
    //                 <svg class="icon__body" role="img" aria-label="Medium">
    //                   {/* <use xlink:href="#medium"></use> */}
    //                 </svg>
    //               </a>
    //             </li>
    //             <li>
    //               <a
    //                 class="icon icon--small"
    //                 href="https://github.com/ckeditor/ckeditor-dev"
    //                 target="_blank"
    //                 rel="noopener noreferrer nofollow"
    //                 title="CKEditor 4 on GitHub."
    //               >
    //                 <svg class="icon__body" role="img" aria-label="github logo">
    //                   {/* <use xlink:href="#github"></use> */}
    //                 </svg>
    //               </a>
    //             </li>
    //           </ul>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div class="section-container footer-policy">
    //     <div class="row dashboard-link">
    //       <div class="col-xs-12">
    //         <p>
    //           To manage your existing license subscriptions and products, please log in to the{' '}
    //           <a href="https://dashboard.ckeditor.com/login" target="_blank" rel="noopener">
    //             dashboard
    //           </a>
    //           .
    //         </p>
    //       </div>
    //     </div>
    //     <div class="row">
    //       <div class="col-xs-12">
    //         <p class="footer-policy__rights">
    //           © 2003 - 2021 CKSource sp. z o.o. sp.k. All rights reserved.
    //         </p>
    //         <ul class="footer-policy__menu">
    //           <li class="footer-policy__menu-item">
    //             <a href="/legal/">Legal</a>
    //           </li>
    //           <li class="footer-policy__menu-item">
    //             <a href="/legal/privacy-policy/">Privacy policy</a>
    //           </li>
    //           <li class="footer-policy__menu-item">
    //             <a href="/legal/ckeditor-oss-license/">Proud to be Open Source</a>
    //           </li>
    //         </ul>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
  );
};

export default Footer;
